import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Mumbaitoalibaugcab() {



    const cardData = {

keyword: "Mumbai to Alibaug Cab",

headingDescription:
    "Mumbai Airport Cab offers safe, comfortable, and reliable Mumbai to Alibaug Cab services for family vacations, weekend getaways, corporate outings, beach holidays, and sightseeing tours. We provide well-maintained Sedan, SUV, Innova Crysta, Ertiga, Tempo Traveller, Luxury Urbania, and Mini Bus options with experienced chauffeurs for a smooth coastal journey. With doorstep pickup across Mumbai, Mumbai Airport transfers, one-way and round-trip cab bookings, customized sightseeing plans, 24/7 customer support, and transparent pricing, we ensure a hassle-free and enjoyable trip to Alibaug, one of Maharashtra's most popular beach destinations known for its scenic coastline, historic forts, ancient temples, and peaceful atmosphere.",

topPlaces: [
    {
        title: "Alibaug Beach",
        description:
            "Alibaug Beach is the most famous attraction in the region and is known for its wide shoreline, black sand, and beautiful views of the Arabian Sea. Visitors enjoy horse carriage rides, beach walks, water sports, local seafood, and spectacular sunsets. The beach also offers a clear view of the historic Kolaba Fort, making it a perfect destination for families, couples, and weekend travelers from Mumbai."
    },
    {
        title: "Kolaba Fort",
        description:
            "Kolaba Fort is a historic sea fort built by Chhatrapati Shivaji Maharaj and stands as one of Alibaug's most iconic landmarks. Accessible on foot during low tide or by boat during high tide, the fort features ancient temples, freshwater wells, and impressive fortifications. History lovers and photographers enjoy exploring its rich heritage while admiring panoramic views of the Arabian Sea."
    },
    {
        title: "Varsoli Beach",
        description:
            "Varsoli Beach is a peaceful and scenic destination located close to Alibaug town, known for its clean shoreline and tranquil environment. The beach is ideal for morning walks, family picnics, photography, and relaxing by the sea. Coconut trees and gentle waves create a refreshing atmosphere for visitors seeking a quiet coastal experience."
    },
    {
        title: "Nagaon Beach",
        description:
            "Nagaon Beach is one of the most popular beaches near Alibaug and is famous for its soft sand, water sports, and rows of coconut and betel nut trees. Visitors can enjoy jet skiing, banana boat rides, parasailing, and beachside dining while spending quality time with family and friends. The beach is a favorite destination for adventure and leisure activities."
    },
    {
        title: "Kihim Beach",
        description:
            "Kihim Beach is renowned for its natural beauty, lush greenery, and peaceful surroundings. The beach is home to diverse bird species and unique coastal vegetation, making it attractive to nature lovers and photographers. Visitors enjoy relaxing walks, quiet moments by the sea, and exploring the scenic landscape away from crowded tourist areas."
    },
    {
        title: "Murud-Janjira Fort",
        description:
            "Murud-Janjira Fort is one of India's most magnificent sea forts and is located a short drive from Alibaug. Built on an island in the Arabian Sea, the fort is famous for its strong defensive architecture and fascinating history. Boat rides to the fort and guided tours provide visitors with an unforgettable experience of Maharashtra's maritime heritage."
    },
    {
        title: "Kanakeshwar Temple",
        description:
            "Kanakeshwar Temple is an ancient hilltop temple dedicated to Lord Shiva and is surrounded by dense forests and scenic landscapes. Visitors climb a series of steps to reach the temple and enjoy breathtaking views of the Konkan coastline along the way. The peaceful environment and spiritual significance make it an important attraction near Alibaug."
    },
    {
        title: "Revdanda Beach and Fort",
        description:
            "Revdanda Beach is known for its serene coastline and the historic Portuguese fort located nearby. The ancient fort walls, old churches, and scenic beach create a unique combination of history and natural beauty. Visitors enjoy exploring the ruins, relaxing by the sea, and experiencing the cultural heritage of the Konkan region."
    },
    {
        title: "Kashid Beach",
        description:
            "Kashid Beach is famous for its sparkling white sand, clear blue waters, and picturesque surroundings. It is one of the most beautiful beaches in Maharashtra and offers opportunities for water sports, beach camping, and peaceful relaxation. The scenic coastal drive to Kashid adds to the overall charm of the Mumbai to Alibaug cab journey."
    },
    {
        title: "Birla Temple and Local Alibaug Markets",
        description:
            "The Birla Temple near Alibaug is admired for its elegant architecture and peaceful surroundings, attracting devotees and tourists alike. Visitors can also explore the local markets for traditional handicrafts, fresh seafood, Konkani delicacies, and local products. The combination of spiritual experiences, shopping, and authentic coastal culture provides a memorable conclusion to an Alibaug tour."
    }
],



services: [
{
name: "Mumbai to Alibaug Cab",
description: "Mumbai Airport Cab offers Mumbai to Alibaug Cab service for comfortable, safe, and affordable travel to one of Maharashtra's most popular beach destinations. Whether you are planning a family holiday, weekend getaway, corporate outing, beach vacation, sightseeing trip, or romantic escape, we provide well-maintained AC Sedan, Ertiga, Innova Crysta, Kia Carens, SUV, Tempo Traveller, and luxury vehicles. Our experienced chauffeurs ensure a smooth journey with doorstep pickup, flexible travel schedules, one way and round trip options, transparent pricing, and 24x7 booking assistance. Enjoy convenient transportation to Alibaug's famous beaches, forts, temples, resorts, and tourist attractions with premium travel comfort and reliable service from Mumbai Airport Cab."
},
{
name: "Mumbai to Alibaug Taxi",
description: "Book Mumbai to Alibaug Taxi with Mumbai Airport Cab for a safe, comfortable, and hassle-free journey. Our professional drivers, clean AC vehicles, affordable rates, and flexible pickup options make every trip enjoyable for families, couples, and groups."
},
{
name: "Mumbai to Alibaug Taxi Fare",
description: "Get affordable Mumbai to Alibaug Taxi Fare with Mumbai Airport Cab. We provide transparent pricing, multiple vehicle choices, no hidden charges, and economical travel packages for one way and round trip journeys."
},
{
name: "Mumbai to Alibaug Cab Fare",
description: "Mumbai Airport Cab offers competitive Mumbai to Alibaug Cab Fare with reliable service, experienced chauffeurs, comfortable vehicles, and convenient booking options for all travellers."
},
{
name: "Cab from Mumbai to Alibaug",
description: "Choose a Cab from Mumbai to Alibaug with Mumbai Airport Cab and enjoy a comfortable coastal journey with experienced drivers, premium AC vehicles, and dependable travel service."
},
{
name: "Mumbai to Alibaug Car Rental",
description: "Book Mumbai to Alibaug Car Rental with chauffeur-driven vehicles for flexible and comfortable travel. We offer Sedan, Ertiga, Innova Crysta, SUV, and luxury cars for every travel requirement."
},
{
name: "Mumbai to Alibaug Cab Booking",
description: "Mumbai Airport Cab provides Mumbai to Alibaug Cab Booking with instant confirmation, 24x7 customer support, professional chauffeurs, and multiple vehicle options."
},
{
name: "Mumbai to Alibaug One Way Cab",
description: "Travel conveniently with Mumbai to Alibaug One Way Cab service featuring fixed pricing, comfortable AC vehicles, experienced drivers, and doorstep pickup and drop."
},
{
name: "Mumbai to Alibaug Round Trip Cab",
description: "Mumbai Airport Cab offers Mumbai to Alibaug Round Trip Cab packages for same-day returns, weekend vacations, beach holidays, and sightseeing tours with flexible schedules."
},
{
name: "Mumbai to Alibaug Ferry + Cab Service",
description: "Book Mumbai to Alibaug Ferry + Cab Service with Mumbai Airport Cab for a seamless travel experience combining ferry connectivity and comfortable road transportation."
},
{
name: "Mumbai to Alibaug Outstation Cab",
description: "Mumbai Airport Cab provides Mumbai to Alibaug Outstation Cab service with premium vehicles, affordable fares, one way and round trip options, and reliable long-distance travel."
},
{
name: "Mumbai to Alibaug Taxi Service",
description: "Choose Mumbai to Alibaug Taxi Service with Mumbai Airport Cab for safe transportation, clean vehicles, professional chauffeurs, and convenient travel arrangements."
},
{
name: "Mumbai to Alibaug Car Hire",
description: "Mumbai Airport Cab offers Mumbai to Alibaug Car Hire with chauffeur-driven vehicles, flexible schedules, comfortable seating, and personalized travel services."
},
{
name: "Mumbai to Alibaug Innova Cab",
description: "Book Mumbai to Alibaug Innova Cab for spacious and comfortable family travel with ample luggage capacity and premium AC interiors."
},
{
name: "Mumbai to Alibaug Ertiga Cab",
description: "Mumbai Airport Cab provides Mumbai to Alibaug Ertiga Cab service for economical family travel with comfortable seating, AC comfort, and affordable pricing."
},
{
name: "Mumbai to Alibaug SUV Cab",
description: "Choose Mumbai to Alibaug SUV Cab for larger families and groups seeking spacious interiors, premium comfort, and smooth long-distance travel."
},
{
name: "Mumbai to Alibaug Weekend Cab",
description: "Book Mumbai to Alibaug Weekend Cab for relaxing short holidays with flexible pickup timings, premium vehicles, and reliable chauffeur-driven transportation."
},
{
name: "Mumbai to Alibaug Beach Cab",
description: "Mumbai Airport Cab offers Mumbai to Alibaug Beach Cab service for convenient travel to Alibaug's beautiful beaches, resorts, and coastal attractions."
},
{
name: "Mumbai Airport to Alibaug Cab",
description: "Book Mumbai Airport to Alibaug Cab with direct pickup from domestic and international terminals. We provide flight tracking, luggage assistance, and comfortable AC vehicles."
},
{
name: "Navi Mumbai to Alibaug Cab",
description: "Mumbai Airport Cab offers Navi Mumbai to Alibaug Cab service with doorstep pickup, affordable fares, comfortable vehicles, and flexible travel options."
},
{
name: "Thane to Alibaug Cab",
description: "Choose Thane to Alibaug Cab with Mumbai Airport Cab for reliable transportation, experienced drivers, premium vehicles, and comfortable coastal travel."
}
],

tableData: [
["Mumbai to Alibaug Cab","Mumbai to Alibaug Taxi"],
["Mumbai to Alibaug Taxi Fare","Mumbai to Alibaug Cab Fare"],
["Cab from Mumbai to Alibaug","Mumbai to Alibaug Car Rental"],
["Mumbai to Alibaug Cab Booking","Mumbai to Alibaug One Way Cab"],
["Mumbai to Alibaug Round Trip Cab","Mumbai to Alibaug Ferry + Cab Service"],
["Mumbai to Alibaug Outstation Cab","Mumbai to Alibaug Taxi Service"],
["Mumbai to Alibaug Car Hire","Mumbai to Alibaug Innova Cab"],
["Mumbai to Alibaug Ertiga Cab","Mumbai to Alibaug SUV Cab"],
["Mumbai to Alibaug Weekend Cab","Mumbai to Alibaug Beach Cab"],
["Mumbai Airport to Alibaug Cab","Navi Mumbai to Alibaug Cab"],
["Thane to Alibaug Cab","Mumbai to Alibaug Tourist Cab"]
],




whychoose: [
{
WhyChooseheading: "Reliable Mumbai to Alibaug Cab Service",
WhyChoosedescription: "Mumbai Airport Cab Service provides dependable Mumbai to Alibaug Cab transportation for families, tourists, couples, corporate travelers, and weekend vacationers seeking a comfortable travel experience."
},
{
WhyChooseheading: "Perfect Weekend Getaway Travel",
WhyChoosedescription: "Alibaug is one of the most popular beach destinations near Mumbai, and our cab service offers convenient door-to-door transportation for relaxing holidays."
},
{
WhyChooseheading: "Comfortable Beach Destination Journey",
WhyChoosedescription: "Enjoy a smooth and scenic drive from Mumbai to Alibaug with our clean vehicles, experienced drivers, and comfortable seating arrangements."
},
{
WhyChooseheading: "Multiple Vehicle Options Available",
WhyChoosedescription: "Customers can choose Sedan cars, Ertiga, Innova Crysta, SUVs, Tempo Travellers, and luxury vehicles according to passenger count and travel preferences."
},
{
WhyChooseheading: "One-Way and Round Trip Facilities",
WhyChoosedescription: "Whether you require a one-way drop, round trip, same-day return, or customized sightseeing package, we provide flexible booking options."
},
{
WhyChooseheading: "Pickup Available Across Mumbai",
WhyChoosedescription: "Doorstep pickup services are available from Mumbai Airport, Navi Mumbai, Thane, Andheri, Borivali, Dadar, Bandra, Powai, and nearby locations."
},
{
WhyChooseheading: "Safe and Professional Drivers",
WhyChoosedescription: "Our trained drivers and regularly maintained vehicles ensure a safe, comfortable, and stress-free journey throughout the trip."
},
{
WhyChooseheading: "Ideal for Families, Couples, and Groups",
WhyChoosedescription: "From romantic beach vacations to family outings and corporate retreats, we provide suitable vehicles for every type of traveler."
}
]
};

const faqData = [
{
question: "Why do travelers frequently book Mumbai to Alibaug Cabs?",
answer: "Alibaug is famous for its beaches, forts, resorts, water sports, and peaceful coastal atmosphere, making it a popular getaway destination."
},
{
question: "Can I book a one-way cab from Mumbai to Alibaug?",
answer: "Yes, one-way cab services are available along with round-trip and customized travel packages."
},
{
question: "Which vehicle is suitable for Mumbai to Alibaug travel?",
answer: "Sedan cars, Ertiga, and Innova Crysta are among the most popular choices for comfortable beach destination travel."
},
{
question: "Are same-day return trips available?",
answer: "Yes, customers can choose same-day return travel depending on their schedule and sightseeing plans."
},
{
question: "Can families use this service for vacations?",
answer: "Yes, families frequently book Mumbai to Alibaug Cabs for holidays, beach outings, and weekend trips."
},
{
question: "Do you provide Tempo Travellers for group travel?",
answer: "Yes, Tempo Travellers and larger vehicles are available for family groups, corporate outings, and group tours."
},
{
question: "Can customers start the journey from Mumbai Airport?",
answer: "Yes, pickup services are available from Mumbai Airport, railway stations, hotels, offices, and residential locations."
},
{
question: "Can sightseeing locations be included during the trip?",
answer: "Yes, customers can include Alibaug Beach, Kolaba Fort, Nagaon Beach, Kihim Beach, Murud-Janjira Fort, and other attractions."
},
{
question: "Is advance reservation recommended for Mumbai to Alibaug travel?",
answer: "Yes, advance booking helps secure preferred vehicles and ensures smooth travel planning, especially during weekends and holidays."
},
{
question: "How can I book a Mumbai to Alibaug Cab?",
answer: "Bookings can be made through phone calls, WhatsApp messages, or online inquiries with Mumbai Airport Cab Service."
}
];

const testimonials = [
{
id: 1,
name: "Mr. Karan Mehta",
feedback:
"We booked a Mumbai to Alibaug Cab for a family beach vacation. The vehicle was comfortable, the driver was professional, and the journey was smooth from start to finish.",
rating: 5
},
{
id: 2,
name: "Mrs. Snehal Patil",
feedback:
"Our Alibaug weekend getaway was excellent with Mumbai Airport Cab Service. The pickup was punctual, the cab was clean, and the entire travel experience was enjoyable and stress-free.",
rating: 5
}
];
































   const Images = [
    { place: "/images/keyword/114.jpg", text: "Mumbai Outstation Cabs", link: "Mumbai-Outstation-Cabs" },
    { place: "/images/keyword/113.jpg", text: "Mumbai to Mahabaleshwar Cab", link: "Mumbai-to-Mahabaleshwar-Cab" },
    { place: "/images/keyword/112.jpg", text: "Mumbai to Goa Cabs", link: "Mumbai-to-Goa-Cabs" },
    { place: "/images/keyword/111.jpg", text: "Mumbai to Shirdi Cab", link: "Mumbai-to-Shirdi-Cab" },
    { place: "/images/keyword/110.jpg", text: "Mumbai Nashik Cab", link: "Mumbai-Nashik-Cab" },
    { place: "/images/keyword/109.jpg", text: "Mumbai to Kolhapur Cab", link: "Mumbai-to-Kolhapur-Cab" },
    { place: "/images/keyword/108.jpg", text: "Mumbai to Pune Cab", link: "Mumbai-to-Pune-Cab" },
    { place: "/images/keyword/107.jpg", text: "Mumbai to Aurangabad Cab", link: "Mumbai-to-Aurangabad-Cab" },
    { place: "/images/keyword/106.jpg", text: "Mumbai to Bhimashankar Cab", link: "Mumbai-to-Bhimashankar-Cab" },
    { place: "/images/keyword/105.jpg", text: "Mumbai to Ashtavinayak Cab Service", link: "Mumbai-to-Ashtavinayak-Cab-Service" },
    { place: "/images/keyword/104.jpg", text: "Mumbai to 5 Jyotirlinga Cab", link: "Mumbai-to-5-Jyotirlinga-Cab" },
    { place: "/images/keyword/103.jpg", text: "Mumbai to Lonavala Cab", link: "Mumbai-to-Lonavala-Cab" },
    { place: "/images/keyword/102.jpg", text: "Mumbai to Konkan Darshan Cab Booking", link: "Mumbai-to-Konkan-Darshan-Cab-Booking" },
    { place: "/images/keyword/101.jpg", text: "Mumbai to Alibaug Cab", link: "Mumbai-to-Alibaug-Cab" },
    { place: "/images/keyword/100.jpg", text: "Mumbai to Ahmednagar Cab", link: "Mumbai-to-Ahmednagar-Cab" },
    { place: "/images/keyword/99.jpg", text: "Mumbai to Matheran Cab", link: "Mumbai-to-Matheran-Cab" },
    { place: "/images/keyword/98.jpg", text: "Mumbai to Jalgaon Cab Booking / Dhule", link: "Mumbai-to-Jalgaon-Dhule-Cab-Booking" },
    { place: "/images/keyword/97.jpg", text: "Mumbai to Lavasa Cab", link: "Mumbai-to-Lavasa-Cab" },
    { place: "/images/keyword/96.jpg", text: "Mumbai to Panchgani Cab", link: "Mumbai-to-Panchgani-Cab" },
    { place: "/images/keyword/95.jpg", text: "Mumbai to Khandala Taxi Fare", link: "Mumbai-to-Khandala-Taxi-Fare" },
    { place: "/images/keyword/94.jpg", text: "Mumbai to Surat Cab", link: "Mumbai-to-Surat-Cab" },
    { place: "/images/keyword/93.jpg", text: "Mumbai to Ahmedabad Cab", link: "Mumbai-to-Ahmedabad-Cab" },
    { place: "/images/keyword/92.jpg", text: "Mumbai to Narmada Parikrama Cab Booking", link: "Mumbai-to-Narmada-Parikrama-Cab-Booking" },
    { place: "/images/keyword/91.jpg", text: "Mumbai to Baroda Cabs", link: "Mumbai-to-Baroda-Cabs" },
    { place: "/images/keyword/90.jpg", text: "Mumbai to Daman Taxi", link: "Mumbai-to-Daman-Taxi" },
];












const productSchema = {
"@context": "https://schema.org",
"@type": "Product",
"name": "Mumbai to Alibaug Cab",
"image": "https://www.mumbaiairportcabs.com/assets/images/mumbai-to-alibaug-cab.jpg",
"description": "Book Mumbai to Alibaug cab service for a smooth and comfortable coastal getaway. Mumbai Airport Cabs offers reliable taxi service with professional drivers, well-maintained vehicles like SUV, Innova, and Ertiga, transparent pricing, and flexible one-way and round-trip options for Alibaug trips.",
"brand": {
"@type": "Brand",
"name": "Mumbai Airport Cabs"
},
"aggregateRating": {
"@type": "AggregateRating",
"bestRating": "5",
"worstRating": "1",
"ratingValue": "4.8",
"ratingCount": "5471"
},
"offers": {
"@type": "Offer",
"priceCurrency": "INR",
"price": "Starting From ₹14/Km",
"availability": "https://schema.org/InStock",
"url": "https://www.mumbaiairportcabs.com/mumbai-to-alibaug-cab"
}
};





    return (
        <div>




<Helmet>
  <title>Mumbai to Alibaug Cab | Ferry & Taxi Service | +91 9545731161</title>

<meta
 name="description"
 content="Book Mumbai to Alibaug cab service with ferry + taxi options. Affordable and reliable cab service with SUV, Innova, Ertiga, and comfortable cars for weekend and outstation trips to Alibaug."
/>

<meta
 name="keywords"
 content="mumbai to alibaug cab, mumbai to alibaug taxi, mumbai to alibaug taxi fare, mumbai to alibaug cab fare, cab from mumbai to alibaug, mumbai to alibaug car rental, mumbai to alibaug cab booking, mumbai to alibaug one way cab, mumbai to alibaug round trip cab, mumbai to alibaug ferry cab service, mumbai to alibaug outstation cab, mumbai to alibaug taxi service, mumbai to alibaug car hire, mumbai to alibaug innova cab, mumbai to alibaug ertiga cab, mumbai to alibaug suv cab, mumbai to alibaug weekend cab"
/>

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>

</Helmet>






            <div
                className="breadcumb-wrapper"
                style={{
                    backgroundImage: "url('/images/breadcumb/breadcumb-bg.jpg')",
                    backgroundSize: "cover",
                    backgroundPosition: "center",
                }}
            >
                <div className="container z-index-common">
                    <div className="breadcumb-content">
                        <h1 className="breadcumb-title">{cardData.keyword}</h1>
                    </div>
                </div>
            </div>


















            <section>
                <div className="container-fluid" >
                    <div className="row container-fluid">
                        <div className="col-12 col-md-7 bg-foootr">
                            <img src='/images/keyword/101.jpg' alt='img' className='img-fluid' />
                            <h3 className="py-1"
                                style={{
                                    color: '#1A4160', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >Mumbai Airport Cab: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="topPlaces">

                                <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                                {cardData.topPlaces.map((place, index) => (
                                    <article key={index} className="placeCard borderr" tabIndex="0">
                                        <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                                        <div className="placeBody">
                                            <h4 className="placeTitle">{place.title}</h4>
                                            <p className="placeDesc">{place.description}</p>

                                        </div>

                                        <span className="placeArrow" aria-hidden>›</span>
                                    </article>
                                ))}
                            </div>


                            <div className="services-section">
                                {cardData.services.map((service, index) => (
                                    <div key={index} className="service-row">
                                        {/* <div className="service-icon">
                      🚗
                    </div> */}
                                        <div>
                                            <h4 className="service-title">{service.name}</h4>
                                            <p className="service-desc">{service.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>


                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section" className="why-choose-section">


                                {/* Section Title */}
                                <h2 className="section-title text-white">
                                    Why Choose <span>Mumbai Airport Cabs</span>
                                </h2>


                                {/* Cards */}
                                <div className="cards-grid">
                                    {cardData.whychoose.map((item, index) => (
                                        <div key={index} className="why-card">
                                            <div className="icon-circle">{index + 1}</div>
                                            <h4 className="card-heading">{item.WhyChooseheading}</h4>
                                            <p className="card-desc">{item.WhyChoosedescription}</p>
                                        </div>
                                    ))}
                                </div>
                            </div>



                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Mumbai Airport Cabs </h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">

                                                <FaqSection
                                                    title=""
                                                    subtitle=""
                                                    items={faqData}
                                                />

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <TestimonialSectionKeyword
                                testimonials={testimonials}
                            />


                            <ContactShowcase keyword={cardData.keyword} />
                        </div>

                        <div className='col-12 col-md-4' >
                            <div className="routeList">
                                {Images.map((e, i) => {
                                    const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                                    const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                                    return (
                                        <a
                                            key={e.link || i}
                                            href={href}
                                            className="routeItem"
                                            aria-label={e.text}
                                            {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                                        >
                                            <div className="routeThumb">
                                                <img src={e.place} alt="" loading="lazy" />
                                            </div>

                                            <div className="routeMeta">
                                                <h6 className="routeTitle">{e.text}</h6>
                                                <span className="routeUnderline" />
                                            </div>

                                            <span className="routeArrow" aria-hidden>›</span>
                                        </a>
                                    );
                                })}
                            </div>




                            <div>
                                <FleetHighway />
                            </div>
                            <div className="pc-contact">
                                <h4 className="pc-title">Contact Information</h4>

                                <div className="pc-grid">
                                    {/* Phones */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-telephone-fill"></i>
                                            <span>Phone Numbers</span>
                                        </header>

                                        <div className="pc-list">
                                            <a href="tel:+919545731161" className="pc-call">+91 9545731161</a>
                                        </div>

                                        <div className="pc-cta">
                                            <a
                                                href="https://wa.me/919545731161"
                                                target="_blank"
                                                rel="noopener noreferrer"
                                                className="pc-whats"
                                            >
                                                <i className="bi bi-whatsapp"></i> WhatsApp
                                            </a>
                                            <a href="tel:+919545731161" className="pc-primary">
                                                Call Now
                                            </a>
                                        </div>
                                    </section>

                                    {/* Email */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-envelope-fill"></i>
                                            <span>Email</span>
                                        </header>

                                        <a href="mailto:booking@mumbaiairportcabs.com" className="pc-email">
                                            booking@mumbaiairportcabs.com
                                        </a>
                                    </section>

                                    {/* Address */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-geo-alt-fill"></i>
                                            <span>Address</span>
                                        </header>

                                        <address className="pc-address">
                                            <strong>Mumbai Airport Cabs</strong><br />

                                            SAWANT SADAN 05 Ramachandra cold drinks House,
                                            Near SBI Bank Nehru Road Opp Noble Medical,
                                            Vile Parle East Mumbai, 400057
                                        </address>
                                    </section>
                                </div>
                            </div>


                        </div>
                    </div>
                </div>
            </section>


        </div>
    );
}

export default Mumbaitoalibaugcab;